/* eslint-disable no-console */
import {FC, PropsWithChildren} from "react";
import {ScriptStatus} from "./ScriptStatus";
import {useScript} from "./useScript";
import {DefaultLoadingIndicator} from "./DefaultLoadingIndicator";
import {DefaultFailureIndicator} from "./DefaultFailureIndicator";
import {ScriptDefinition} from "./ScriptDefinition";
import {ScriptPlaceholderProps} from "./ScriptPlaceholderProps";

export type ScriptLoaderProps = ScriptPlaceholderProps & ScriptDefinition;

/**
 * The {@link ScriptLoader} dynamically injects a script and presents a loading
 * status user interface. For script injection without an associated user
 * interface, the Script component may be used.
 *
 * @see useScript
 * @see Script
 * @see ScriptObserver
 */
export const ScriptLoader: FC<PropsWithChildren<ScriptLoaderProps>> = ({
  id,
  source,
  async,
  defer,
  loading = DefaultLoadingIndicator,
  failure = DefaultFailureIndicator,
  children
}) => {
  const Loading = loading;
  const Failure = failure;
  const status = useScript({id, source, async, defer});
  console.info(`Rendering script ${id} with status ${status}`);
  switch (status) {
    case ScriptStatus.LOADED:
      return <>{children}</>;
    case ScriptStatus.LOADING:
      return <Loading scriptId={id} />;
    case ScriptStatus.FAILED:
      return <Failure scriptId={id} />;
  }
};
